import { Modal } from 'antd'
import dayjs from 'dayjs'
import styles from './index.module.scss'
import { timeRange } from '@/utils'

export default () => {
  const [show, setShow] = useState(false)

  const { userInfo } = useUserInfoStore()

  /** 是否在今天弹出过弹窗 */
  const isAlertAtNowDay = () => {
    const nowTime = localStorage.getItem('nowTime')
    if (!nowTime) return false

    // 本地时间 === 当前时间，今天已经弹出过弹窗
    if (nowTime === dayjs().format('YYYY-MM-DD')) {
      return true
    }
    return false
  }

  /** 关闭弹窗 */
  const closeModal = () => {
    setShow(false)
    localStorage.setItem('nowTime', dayjs().format('YYYY-MM-DD'))
  }

  const toPage = () => {
    window.open(`${websiteUrl}common/618`)
  }

  useEffect(() => {
    const start = '2024-05-26'
    const end = '2024-07-01'
    const bool = timeRange(start, end) && !isAlertAtNowDay()

    if (bool) {
      setShow(true)
    }
  }, [userInfo])

  // 未登录
  if (!userInfo?.uid) return null

  const renderModal = () => {
    return (
      <div className={styles.imageBox}>
        <img className={styles.image} src={`${CDN_URL}618-modal.png`} alt="" onClick={toPage} />
        <img className={styles.close} src={`${CDN_URL}pc-close.png`} onClick={closeModal} />
      </div>
    )
  }

  return (
    <Modal
      open={show}
      modalRender={renderModal}
      wrapClassName={styles.wrapClassName}
      style={{ pointerEvents: 'auto', top: '50%', marginTop: '-250px', height: '500px' }}
      zIndex={999999}
    />
  )
}
